var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{staticClass:"aha-antd-button",class:[
    {
      'btn-underline': _vm.underline,
      'mr-4': _vm.hasMarginRight,
      'ml-4': _vm.hasMarginLeft,
      'disabled': _vm.disabled,
    },
    `ant-btn-${_vm.variant}`,
    `btn-${_vm.size}`,
    'ant-btn-custom'
  ],attrs:{"type":_vm.variant,"loading":_vm.submitting,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.iconName.length && !_vm.submitting)?_c('aha-icon',{class:_vm.iconClasses,attrs:{"name":_vm.iconName,"height":_vm.iconHeight,"width":_vm.iconHeight,"viewBox":_vm.iconViewBox}}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingInline || !_vm.submitting),expression:"!isLoadingInline || !submitting"}]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }